import { render } from "./SourceList.vue?vue&type=template&id=97747b84&scoped=true"
import script from "./SourceList.vue?vue&type=script&lang=js"
export * from "./SourceList.vue?vue&type=script&lang=js"

import "./SourceList.vue?vue&type=style&index=0&id=97747b84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97747b84"]])

export default __exports__